// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"200":"fc11c758","311":"5799639d"}[chunkId] + ".js";
};